import { render, staticRenderFns } from "./goodsfreightReduction.vue?vue&type=template&id=28a61afe&"
import script from "./goodsfreightReduction.vue?vue&type=script&lang=js&"
export * from "./goodsfreightReduction.vue?vue&type=script&lang=js&"
import style0 from "./goodsfreightReduction.vue?vue&type=style&index=0&id=28a61afe&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28a61afe')) {
      api.createRecord('28a61afe', component.options)
    } else {
      api.reload('28a61afe', component.options)
    }
    module.hot.accept("./goodsfreightReduction.vue?vue&type=template&id=28a61afe&", function () {
      api.rerender('28a61afe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/freightReduction/goodsfreightReduction.vue"
export default component.exports